<template>
  <div class="uploadFile" v-loading.fullscreen.lock="loading">
    <div class="uploadFile_labe" v-if="required" :title="uploadFileLabe">{{uploadFileLabe}}</div>
    <div class="uploadFile_labe1" v-else>{{uploadFileLabe}}</div>
    <div class="uploadFile_content">
      <div class="uploadFile_item" v-for="(item,index) in uploadFileArr" :key="item.id">
        <el-upload
          ref="uploadRef"
          :data="{type_key:item.code,type_value:item.file_name,obj_id:StuId}"
          :headers="Uploadheaders"
          :action="actionUrl"
          :multiple="false"
          :limit="1"
          :show-file-list="false"
          :on-success="(response, file, fileList)=>yszgzsUploadSuccess(response, file, fileList,index)"
          :file-list="item.fileArr"
          :on-exceed="uploadExceed"
          :before-upload="(file) =>beforeAvatarUpload(file,item.file_format,item.max_kb)"
          :on-progress="progressFun"
        >
          <Button icon="ios-cloud-upload-outline">上传文件</Button>
          <div slot="tip" class="upload_hint" v-if="item.file_format&&item.max_kb">
            支持格式&nbsp;
            <span style="color:#ff0000;font-size:12px">{{item.file_format}}</span>&nbsp;等，且不超过&nbsp;
            <span style="color:#ff0000;font-size:12px">{{item.max_kb}}</span>&nbsp;kb
          </div>
          <div slot="tip" class="upload_hint" v-if="!item.file_format&&item.max_kb">
            上传的文件大小不能超过&nbsp;
            <span style="color:#ff0000;font-size:12px">{{item.max_kb}}</span>&nbsp;kb
          </div>
          <div slot="tip" class="upload_hint" v-if="item.file_format&&!item.max_kb">
            只能上传&nbsp;
            <span style="color:#ff0000;font-size:12px">{{item.file_format}}</span>&nbsp;文件
          </div>
        </el-upload>
        <div class="uploadFile_list" v-if="item.fileArr.length>0">
          <div
            class="uploadFile_list_item"
            v-for="(items,indexs) in (item.fileArr)"
            :key="items.id"
          >
            <Icon type="ios-image" color="#999" />
            <a :href="fileUrl+items.full_path" target="_blank">&nbsp;{{items.file_name}}</a>
            <Icon type="md-close" size="18" @click="deleteFile(index,indexs,items)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.uploadFile {
  width: 100%;
  display: flex;
  padding-left: 420px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;

  .uploadFile_labe {
    position: absolute;
    left: 0;
    top: 10%;
    width: 420px;
    // height: 35px;
    // line-height: 35px;
    text-align: right;
    padding-right: 12px;
    box-sizing: border-box;
    font-size: 14px;
    color: #515a6e;
    word-wrap:break-word ;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
  }
  .uploadFile_labe1{
    position: absolute;
    left: 0;
    top: 10%;
    width: 420px;
    // height: 35px;
    // line-height: 35px;
    text-align: right;
    padding-right: 12px;
    box-sizing: border-box;
    font-size: 14px;
    color: #515a6e;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .uploadFile_labe:before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }

  .uploadFile_content {
    display: flex;
    width: 100%;

    .uploadFile_item {
      flex: 1;
      padding-bottom: 10px;
    }

    .uploadFile_list {
      padding: 5px 0;

      .uploadFile_list_item {
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        cursor: pointer;
        .ivu-icon-ios-image {
          float: left;
          margin: 8px 5px 0 0;
        }
        a {
          float: left;
          color: #00b49b;
          max-width: 700px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .ivu-icon-md-close {
          float: left;
          color: #00b49b;
          margin: 5px 0 0 5px;
        }
      }
    }
  }
}
</style>
<script>
import util from "@/libs/util";
import { UploadNews, UploadFileList, DeleteFile } from "@/api/upload/index";
import Settting from "@/setting";
export default {
  props: {
    group_id: {
      type: String,
      default() {
        return "";
      }
    },
    StuId: {
      type: String,
      default() {
        return "";
      }
    }
  },
  watch: {
    StuId() {
      let token = util.cookies.get("token");
      this.Uploadheaders = {
        access_token: token
      };
      this.getUploadNew();
    }
  },
  data() {
    return {
      loading: false,
      required: true,
      uploadFileArr: [],
      uploadFileLabe: "",
      actionUrl: Settting.uploadUrl,
      UploadList: [],
      Uploadheaders: null
    };
  },
  methods: {
    //获取上传文件的配置信息
    getUploadNew() {
      UploadNews(this.group_id).then(res => {
        this.uploadFileLabe = res[0].group_name;
        this.required = (res[0].min_count === 0 ? false : true);
        let fileShowList = new Array();
        for (let i = 0; i < res.length; i++) {
          let objs = res[i];
          objs.fileArr = [];
          fileShowList.push(objs);
        }
        this.uploadFileArr = fileShowList;
        //循环获取文件列表
        for (let j = 0; j < this.uploadFileArr.length; j++) {
          this.getFileList(this.uploadFileArr[j].code, j);
        }
      });
    },
    //获取文件列表
    getFileList(id, index) {
      let params = {
        obj_id: this.StuId,
        type_key: id
      };
      UploadFileList(params).then(res => {
        this.$set(this.uploadFileArr[index], "fileArr", res);
      });
    },
    //上传文件超出规定的个数
    uploadExceed() {
      this.$Message.error({
        content: "当前限制只能选择 一个文件",
        duration: 3
      });
    },
    //文件上传类型和大小限制
    beforeAvatarUpload(file, type, size) {
      let isFileType = false;
      let isFileTypeSize = false;
      if (type == null) {
        isFileType = true;
      } else {
        let fileName = file.name.split(".");
        let fileTypeArr = type.split(",");
        for (let i = 0; i < fileTypeArr.length; i++) {
          if (fileTypeArr[i] == "." + fileName[fileName.length - 1]) {
            isFileType = true;
            break;
          }
        }
        //文件类型判断
        if (!isFileType) {
          this.$Message.error({
            content: "上传文件类型只能是" + type + " 格式!",
            duration: 3
          });
        }
      }

      if (size == null) {
        isFileTypeSize = true;
      } else {
        //文件大小判断
        if (size) {
          isFileTypeSize = file.size / 1024 / 1024 < parseFloat(size / 1000);
        } else {
          isFileTypeSize = true;
        }
        if (!isFileTypeSize) {
          this.$Message.error({
            content:
              "上传头像图片大小不能超过" + parseFloat(size / 1000) + "M!",
            duration: 3
          });
        }
      }

      return isFileType && isFileTypeSize;
    },
    //文件上传时
    progressFun() {
      this.loading = true;
    },
    //文件上传成功回调
    yszgzsUploadSuccess(response, file, fileList, index) {
      this.loading = false;
      if (response.code == 40000) {
        this.uploadFileArr[index].fileArr.push(response.data);
        this.$emit("success-change", this.uploadFileArr);
      } else {
        this.$Message.error({
          content: response.msg,
          duration: 3
        });
      }
    },
    //删除文件
    deleteFile(index, indexs, item) {
      this.loading = true;
      DeleteFile(item.id)
        .then(() => {
          this.loading = false;
          this.$Message.success("删除成功!");
          this.uploadFileArr[index].fileArr.splice(indexs, 1);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //验证文件是否上传
    verificationFileUpload() {
      for (let i = 0; i < this.uploadFileArr.length; i++) {
        if (this.uploadFileArr[i].fileArr.length == 0) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>